<template>
    <div class="scan-page">
        <!-- Barcode scanner -->
        <barcode-picker @barcodeHasBeenScanned="barcodeScanned($event)"></barcode-picker>

        <!-- Manual entry -->
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <label>Manually enter the IMEI</label>
                </div>
                <div class="col">
                    <div class="form-group mb-0">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text"><i class="fa fa-search mb-0"></i></span>
                            </div>
                            <input type="text" inputmode="numeric" pattern="[0-9]*" class="form-control" placeholder="Enter IMEI" v-on:keyup.enter="validateImei()" v-model="imei">
                            <span class="input-clear" v-if="imei" @click="clearImei()"><i class="fas fa-times-circle mb-0"></i></span>
                        </div>
                    </div>
                </div>
                <div class="col-auto pl-0">
                    <button class="btn btn-success btn-block d-md-inline-block py-2" @click="validateImei()" :disabled="!imei || validating">
                        <span class="d-md-none"><i class="fa fa-search mr-0"></i></span>
                        <span class="d-none d-md-inline">Search</span>
                    </button>
                </div>
            </div>

            <!-- Validating overlay -->
            <loading-state
                    v-if="validating && !invalidImei"
                    overlay
                    title="Validating IMEI">
            </loading-state>

            <!-- Invalid IMEI -->
            <empty-state
                    v-if="imei && invalidImei"
                    statusIcon="error"
                    :title="`${ imei } <span class='font-weight-light'>is either invalid or the asset has not yet been processed. Try scanning again or check that the asset exists in the admin panel.</span>`">
            </empty-state>

            <!-- Asset states -->
            <asset-states
                    v-if="validImei && !passedDiagnosis"
                    :asset="asset"
                    :imei="imei">
            </asset-states>

            <!-- Invalid IMEI -->
            <empty-state
                    v-if="passedDiagnosis"
                    statusIcon="error"
                    :title="`<span class='font-weight-light'>The asset with the IMEI</span> ${ imei } <span class='font-weight-light'>has already passed the diagnosis stage. Try searching for another IMEI.</span>`">
                <slot>
                    <button class="btn btn-light" @click="printAssetLabel(asset.id)">Reprint asset label</button>
                    <button class="btn btn-light" v-if="asset.job_id" @click="goToJob()">Go to job</button>
                </slot>
            </empty-state>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';

    export default {
        props:['cannotRepairAsset', 'diagnosticsComplete'],

        data() {
            return {
                imei: null,
                invalidImei: false,
                passedDiagnosis: false,
                validating: false,
                validImei: false
            }
        },

        computed: {
            ...mapGetters([
                "asset",
            ])
        },

        watch: {
            imei: function() {
                this.invalidImei = false;
                this.passedDiagnosis = false;
            }
        },

        mounted() {
            this.clearAsset();

            if (this.diagnosticsComplete) {
                this.displayToast({text: 'Asset diagnostic completed', type: 'success'});
            }

            if (this.cannotRepairAsset) {
                this.displayToast({text: 'Asset marked as "cannot repair"', type: 'warning'});
            }
        },

        methods: {
            ...mapActions([
                "clearAsset",
                "displayToast",
                "loadAssetFromReference",
                "printAssetLabel"
            ]),

            /** Barcode scanned */
            barcodeScanned(barcode) {
                this.imei = barcode.data;
                this.validateImei();
            },

            /** Clear the input */
            clearImei() {
                this.imei = null;
                this.validImei = false;
            },

            /** Validate the IMEI */
            validateImei() {
                this.passedDiagnosis = false;
                this.loadAssetFromReference({
                    assetReference: this.imei
                }).then(() => {
                    this.validImei = true;
                    // If the status is Not Yet Received
                    if (!this.passedDiagnosis && this.asset.status_code === 'not-yet-received') {
                        if (this.asset.label_printed) {
                            return this.$router.push({
                                name: 'bulkRepairDiagnostics.confirmProblems',
                                params: {assetId: this.asset.id}
                            });
                        }

                        // If the asset has already passed diagnosis
                        this.$router.push({name: 'bulkRepairPrintLabel', params: {assetId: this.asset.id}});

                    } else {
                        this.passedDiagnosis = true;
                    }
                }).catch(() => {
                    this.invalidImei = true;
                    this.passedDiagnosis = false;
                    this.validImei = false;
                });
            },

            goToJob() {
                this.$router.push({name: `job`, params: {jobId: this.asset.job_id}});
            }
        }
    }
</script>

<style scoped>

</style>